import { useAtom } from 'jotai';

import { languageAtom } from '~shared/atoms';
import { useAccount } from '~teacher/hook/account';
import { isCanadaOrUSA, isEmailShowbie } from '~teacher/util/regexHelpers';
import { isAustraliaOrNewZealandOrUK } from '~teacher/util/regexHelpers/isAustraliaOrNewZealandOrUK';

import platform from '../../../../../../shared/Platform';

export function shouldShowDiscoverTab({
  isIosApp,
  isLanguageEnglish,
  email,
  country,
}: {
  isIosApp: boolean;
  isLanguageEnglish: boolean;
  email: string;
  country: string;
}) {
  if (isIosApp) {
    return false;
  }

  if (
    isLanguageEnglish ||
    isEmailShowbie(email) ||
    isCanadaOrUSA(country) ||
    isAustraliaOrNewZealandOrUK(country)
  ) {
    return true;
  }

  return false;
}

export function useShouldShowDiscoverTab() {
  const [language] = useAtom(languageAtom);
  const account = useAccount({
    select: ({ country, email }) => ({ email, country }),
  });

  return shouldShowDiscoverTab({
    isIosApp: platform.isIosApp,
    isLanguageEnglish: /^en/i.test(language),
    email: account.data?.email ?? '',
    country: account.data?.country ?? '',
  });
}
